export * from './table-view-link.component';
